<template lang="pug">
.text-box-editor
  editor-menu-bar(:editor="editor")
    .menubar(slot-scope="{ commands, isActive }")
      md-button.md-raised.menubar__button.undo(type="button" @click="commands.undo" tabindex="2")
        i.material-icons undo
      md-button.md-raised.menubar__button.redo(type="button" @click="commands.redo" tabindex="3")
        i.material-icons redo
      //- md-button.md-raised.menubar__button.paragraph(:class="{ 'is-active': isActive.paragraph() }" type="button" @click="commands.paragraph")
      //-   i.material-icons format_textdirection_l_to_r
      .menubar__button_groups
        div Formatos
        .buttons
          md-button.md-raised.menubar__button.bold(:class="{ 'is-active': isActive.bold() }" type="button" @click="commands.bold" tabindex="4")
            i.material-icons format_bold
          md-button.md-raised.menubar__button.italic(:class="{ 'is-active': isActive.italic() }" type="button" @click="commands.italic" tabindex="5")
            i.material-icons format_italic
          md-button.md-raised.menubar__button.underline(:class="{ 'is-active': isActive.underline() }" type="button" @click="commands.underline" tabindex="6")
            i.material-icons format_underlined
          md-button.md-raised.menubar__button.strike(:class="{ 'is-active': isActive.strike() }" type="button" @click="commands.strike" tabindex="7")
            i.material-icons strikethrough_s
      .menubar__button_groups
        div
          i.material-icons format_size
          | Títulos
        .buttons
          md-button.md-raised.menubar__button.heading3(:class="{ 'is-active': isActive.heading({ level: 3 }) }" type="button" @click="commands.heading({ level: 3 })" tabindex="7")
            | Normal
          md-button.md-raised.menubar__button.heading2(:class="{ 'is-active': isActive.heading({ level: 2 }) }" type="button" @click="commands.heading({ level: 2 })" tabindex="8")
            | Grande
          md-button.md-raised.menubar__button.heading1(:class="{ 'is-active': isActive.heading({ level: 1 }) }" type="button" @click="commands.heading({ level: 1 })" tabindex="9")
            | Enorme
      .menubar__button_groups
        div Bloques
        .buttons
          md-button.md-raised.menubar__button.bullet_list(:class="{ 'is-active': isActive.bullet_list() }" type="button" @click="commands.bullet_list" tabindex="10")
            i.material-icons format_list_bulleted
          md-button.md-raised.menubar__button.ordered_list(:class="{ 'is-active': isActive.ordered_list() }" type="button" @click="commands.ordered_list" tabindex="11")
            i.material-icons format_list_numbered
          md-button.md-raised.menubar__button.blockquote(:class="{ 'is-active': isActive.blockquote() }" type="button" @click="commands.blockquote" tabindex="12")
            i.material-icons format_quote
          md-button.md-raised.menubar__button.horizontal_rule(type="button" @click="commands.horizontal_rule" tabindex="13")
            i.material-icons minimize
  editor-content.editor-content(:editor="editor" tabindex="1")
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from 'tiptap-extensions'

export default {
  components: { EditorContent, EditorMenuBar },
  props: ['value'],
  data: () => ({
    editor: null
  }),
  methods: {
    loadEditor () {
      if (!this.editor) {
        const self = this
        this.editor = new Editor({
          content: this.value,
          extensions: [
            new Blockquote(),
            new BulletList(),
            new CodeBlock(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new HorizontalRule(),
            new ListItem(),
            new OrderedList(),
            new TodoItem(),
            new TodoList(),
            new Bold(),
            new Code(),
            new Italic(),
            new Link(),
            new Strike(),
            new Underline(),
            new History()
          ],
          onUpdate: val => {
            const value = val.getHTML()
            if (value === '<p></p>') self.$emit('input', '')
            else self.$emit('input', value)
          }
        })
      }
    }
  },
  mounted () {
    this.loadEditor()
  },
  beforeDestroy () {
    if (this.editor) this.editor.destroy()
  },
  watch: {
    value () {
      this.loadEditor()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

$font-color = rgba(0,0,0,0.54)

.text-box-editor
  border: 1px solid rgba(0,0,0,0.12)
  border-radius: 3px

.editor-content
  & >>> .ProseMirror
    margin: $f10px 0 0
    border: 1px solid $font-color
    border-top-left-radius: 0px
    border-top-right-radius: 0px
    border-bottom-right-radius: 3px
    border-bottom-left-radius: 3px
    padding: 0 2px
  p
    margin: $f8px 0
  s
    text-decoration: line-through
  u
    text-decoration: $font-color solid underline

.menubar
  display: flex
  justify-content: space-between
  align-items: flex-end
  flex-wrap: wrap
  &__button
    background-color: white
    min-width: 32px
    height: $f30px
    margin: $f2px $f3px 0 0
    color: $font-color
    .md-ripple
      padding: 0 $f5px
    i.material-icons
      min-height: 16px
      height: $f16px
      font-size: $f16px !important
    &_groups
      box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12)
      border-radius: 3px
      display: inline-block
      min-height: 65px
      display: flex
      flex-direction: column
      justify-content: space-between
      margin-top: $f3px
      div
        text-align: center
      .buttons
        display: flex
        justify-content: space-between
        align-items: center
      .heading1,
      .horizontal_rule,
      .strike
        margin-right: 0

.md-invalid
  &.text-box-editor,
  .editor-content >>> .ProseMirror
    border-color: var(--md-theme-default-fieldvariant, #ff1744)

</style>
